<template>
  <div>
    <dashboard-standard v-if="user.role == 'pemohon'" />
    <dashboard-admin v-else />
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
    }
  },
  components: {
    DashboardAdmin: () => import('./DashboardV3.vue'),
    DashboardStandard: () => import('./DashboardPemohon.vue'),
  },
  created() {
    // Check user role and set one to true.
  },
}
</script>
